import React from 'react'
import Modal from 'react-modal';

Modal.setAppElement('#modal');

export const MessageModal = ({isOpen, onRequestClose, title, message}) => {
    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            padding: '0',
            transform: 'translate(-50%, -50%)'
        }
    };

    return <Modal isOpen={isOpen} onRequestClose={onRequestClose} style={customStyles}>
        <div className="message-modal">
            <div className="modal-title">{title}</div>
            <p className="modal-text">{message}</p>
            <button onClick={onRequestClose}>OK</button>
        </div>
    </Modal>
}


// WEBPACK FOOTER //
// ./src/components/MessageModal.js